import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.parse-int";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    conditions: {
      type: Object
    },
    gradeData: {
      type: Array
    },
    bonusData: {
      type: Array
    },
    levelData: {
      type: Array
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      form: {
        gradeLevel: 0,
        //级别类型  等级、资格
        bonusMode: 0,
        isTighten: 1,
        //是否紧缩
        bonusTag: 0,
        selectGrade: [],
        factorList: [],
        isAfterGrade: 0,
        giveJcBonusType: 0,
        giveBonusTag: 0,
        isEqualGrade: 0,
        orderTypes: [1, 2, 3]
      },
      giveGrade: []
    };
  },
  mounted: function mounted() {
    if (this.conditions) {
      for (var key in this.form) {
        this.form[key] = this.conditions[key];
      }
    }

    this.gradeLevelChange(0);
  },
  methods: {
    gradeLevelChange: function gradeLevelChange(value) {
      if (value == 0) {
        this.giveGrade = this.$tempModel.deepCopy(this.gradeData);
      } else {
        this.giveGrade = this.$tempModel.deepCopy(this.levelData);
      }

      this.giveGrade.push({
        tag: -1,
        name: '公司'
      });

      for (var i in this.giveGrade) {
        this.giveGrade[i].tag = parseInt(this.giveGrade[i].tag);
      }
    },
    getGradeByTag: function getGradeByTag(tag) {
      for (var i in this.gradeData) {
        if (this.gradeData[i].tag == tag) {
          return this.gradeData[i];
        }
      }

      return null;
    },
    createFactor: function createFactor() {
      var tmp = [];

      for (var i in this.form.selectGrade) {
        var item = this.getGradeByTag(this.form.selectGrade[i]);
        tmp.push({
          grade: item.tag,
          gradeName: item.name,
          giveGrade: [],
          specialGrade: [],
          giveMaxMoney: '',
          giveRate: 0,
          rateList: []
        });
      }

      this.form.factorList = tmp;
    },
    clearFactorData: function clearFactorData() {
      this.form.selectGrade = [];
      this.form.factorList = [];
    },
    clickAddLayer: function clickAddLayer(index) {
      this.form.factorList[index].rateList.push({
        rate: 0
      });
    },
    clickDelLayer: function clickDelLayer(index, subIndex) {
      var tmp = this.form.factorList[index].rateList;
      tmp.splice(subIndex, 1);
      this.form.factorList[index].rateList = tmp;
    },
    getParams: function getParams() {
      var params = this.form;
      return this.$tempModel.deepCopy(params);
    }
  }
};